// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"412":"e05f87b7","739":"d3b57477"}[chunkId] + ".chunk.js";
};